import { Component, OnInit } from '@angular/core';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-evaluation-project-kpis',
  templateUrl: './evaluation-project-kpis.component.html',
  styleUrls: ['./evaluation-project-kpis.component.scss']
})
export class EvaluationProjectKpisComponent implements OnInit {

  public expanded: boolean = false;
  public data: any = [];
  public kpis: any = [];
  public kpiObjects: any = [];

  constructor(private router: Router,private req: HttpRequestsService<any>, private keycloak: KeycloakService) { }

  ngOnInit(): void {
    this.req.getEvaluation().subscribe((res) => {
      this.data = res;
      this.data.forEach(element => {
        element.expanded = false;
        console.log(element)
        const kpiObjects = element.Kpis.map(kpi => ({ name: kpi.Kpi, message:kpi.Message, score:kpi.Score, expanded: false,  }));
        this.kpiObjects.push(kpiObjects);
      })
    });
  }

  onClick(category) {
    this.data.forEach(element => {
      if (element.Kpi_Cat == category) {
        element.expanded = !element.expanded;

      }
      else {
        element.expanded = false;
        this.kpiObjects = this.kpiObjects.map(kpiObject => kpiObject.map(kpi => ({ ...kpi, expanded: false })));
      }
    });
  }


  onKpiClick(categoryIndex: number, kpiIndex: number) {
    const clickedKpi = this.kpiObjects[categoryIndex][kpiIndex];
    
    if (clickedKpi.expanded) {
      clickedKpi.expanded = false;
      clickedKpi.cities = [];
    } else {
      this.kpiObjects.forEach((category, cIndex) => {
        category.forEach((kpi, kIndex) => {
          if (categoryIndex === cIndex && kpiIndex === kIndex) {
            kpi.expanded = true;
            this.req.getCitiesByKpi(kpi.name).subscribe((res) => {
              kpi.cities = res;
            });
          } else {
            kpi.expanded = false;
            kpi.cities = [];
          }
        });
      });
    }
  }

  onCity(city,kpi){
    this.keycloak.isLoggedIn().then(res => {
      if (res == true) {
        this.router.navigateByUrl(`Evaluation/KPI/${kpi.name.substring(0, 2)}`, { state: { city: city, kpi: kpi.name } });
      }
      else {
        Swal.fire({
          title: 'You need to log in to access the data for this city',
          icon: "info",
        })
      }
    })
  }
}
